import { createAction } from '@reduxjs/toolkit';

export const scheduleUpdated = createAction('[Socket] scheduleUpdated');
